import { render, staticRenderFns } from "./CardsWithNumbers.vue?vue&type=template&id=6bf66aec"
import script from "./CardsWithNumbers.vue?vue&type=script&lang=js"
export * from "./CardsWithNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports